export const getters = {
  groupIndexingRuleList: ({ groupIndexingRuleList }) => groupIndexingRuleList,
};
